import React, { Fragment, Component } from 'react'
import withWidth, { isWidthDown } from '@material-ui/core/withWidth'
import MobileSessionList from './Mobile/SessionList'
import DesktopSessionList from './Desktop/SessionList'
import {compose} from 'redux'

import { ViewProfileModal } from './Modals/'

import {translate} from 'react-i18next'

class DecisionSessionListView extends Component {
  constructor (props) {
    super (props)
    this.state = {
      isProfileModalOpened: false,
      isMobile: isWidthDown('sm', this.props.width),
      sessionID: null
    }
  }

  onClickViewProfile = (sessionID) => {
    this.setState({
      isProfileModalOpened: true,
      sessionID: sessionID
    })
  }

  renderProfileModal = () => {
    if(this.state.isProfileModalOpened) {
    return (
      <ViewProfileModal
        open={this.state.isProfileModalOpened}
        dismissFn={() => this.setState({ isProfileModalOpened: false })}
        sessionID={this.state.sessionID}
      />
    )
  } else {
    return (null)
  }
  }

render() {
  const {sessions, recallSession} = this.props
  return (
    <Fragment>
      {this.state.isMobile && (
        <MobileSessionList
          sessions={sessions}
          recallSession={recallSession}
          onClickViewProfile={this.onClickViewProfile}
        />        
      )}
      {!this.state.isMobile && (
        <DesktopSessionList
          sessions={sessions}
          recallSession={recallSession}
          onClickViewProfile={this.onClickViewProfile}
        />   
      )}
      {this.renderProfileModal()}
    </Fragment>
  )}
}

export default compose(
  withWidth(),
  translate()
)(DecisionSessionListView)


// WEBPACK FOOTER //
// ./src/components/setup/recall-session/by-decision/SessionList/SessionListView.js